/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { Button } from '@carbon/react';

import { dedicatedModesStore } from 'App/Pages/Diagram/stores';
import { MODES_INDEXES } from 'App/Pages/Diagram/stores/DedicatedModesStore';

export default function Continue({ selectedCluster, isInputValidationSuccessful, enableValidation, closeModal }) {
  const continuee = async () => {
    if (selectedCluster?.authentication === 'CLIENT_CREDENTIALS' && !isInputValidationSuccessful) {
      enableValidation();
      return;
    }

    closeModal();
    dedicatedModesStore.setViewModeIndex(MODES_INDEXES.PLAY);
  };

  return (
    <Button onClick={continuee} type="submit" data-modal-primary-focus>
      Continue
    </Button>
  );
}
